// extracted by mini-css-extract-plugin
export default {"container":"ViewTabs__container___e1gvF","line":"ViewTabs__line___Bssw1","item":"ViewTabs__item___DQ91M","card":"ViewTabs__card___EYhWh"};